import React, { FC, useEffect } from 'react';
import cx from 'classnames';
import { _t, lockBodyScroll } from 'utils';

import iconClose from 'assets/img/projects-menu-v4/icon-close.svg';
import plateOtkroy from 'assets/img/projects-menu-v4/plate-otkroy.png';
import bannerDynasties from 'assets/img/projects-menu-v4/banner-dynasties.png';
import plateDesign from 'assets/img/projects-menu-v4/plate-design.png';
import artGear from 'assets/img/projects-menu-v4/art-gear.png';
import artRobot from 'assets/img/projects-menu-v4/art-robot.png';

import styles from './styles.module.scss';

type Props = {
  onClose: () => void;
};

const PROJECTS = [
  {
    id: 'otkroy',
    title: 'Открой#Моспром',
    href: 'https://otkroimosprom.ru',
    plate: plateOtkroy,
    overflow: true,
    art: null,
  },
  {
    id: 'dynasties',
    title: 'Династии московских промышленников',
    href: 'https://prom-dinastii.otkroimosprom.ru',
    plate: bannerDynasties,
    overflow: false,
    art: null,
  },
  {
    id: 'design',
    title: 'Лучший Промышленный Дизайн',
    href: 'https://design-prom.ru',
    plate: plateDesign,
    overflow: true,
    art: {
      src: artRobot,
      className: 'artRobot' as const,
    },
  },
];

const ProjectsMenu: FC<Props> = ({ onClose }) => {
  useEffect(() => lockBodyScroll(), []);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <div className={styles.root} role="dialog" aria-modal="true" aria-label={_t('Проекты')}>
      <button
        type="button"
        className={styles.backdrop}
        aria-label={_t('Закрыть')}
        onClick={onClose}
      />
      <div className={styles.shelf}>
        <div className={styles.panel}>
          <div className={styles.head}>
            <h2 className={styles.title}>{_t('Проекты')}</h2>
            <button
              type="button"
              className={styles.close}
              aria-label={_t('Закрыть')}
              onClick={onClose}
            >
              <img src={iconClose} alt="" width={16} height={16} />
            </button>
          </div>

          <div className={styles.listWrap}>
            <ul className={styles.list}>
              {PROJECTS.map((item) => (
                <li
                  key={item.id}
                  className={cx(
                    styles.card,
                    item.overflow && styles.cardOverflow,
                    item.id === 'dynasties' && styles.cardOverGear,
                    item.id === 'design' && styles.cardOverMiddle,
                  )}
                >
                  <a
                    href={item.href}
                    className={styles.cardLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={onClose}
                  >
                    <span className={styles.plate}>
                      <img
                        src={item.plate}
                        alt={_t(item.title)}
                        className={styles.plateImg}
                      />
                    </span>
                    {item.art && (
                      <img
                        src={item.art.src}
                        alt=""
                        aria-hidden
                        className={cx(styles.art, styles[item.art.className])}
                      />
                    )}
                  </a>
                </li>
              ))}
            </ul>
            <img
              src={artGear}
              alt=""
              aria-hidden
              className={styles.artGear}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsMenu;
